import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend
} from 'recharts';
import './Dashboard.css';

export default function MonthlyInsectsBar({ data }) {
  // Use centralized palette (CSS variables)
  const colors = [
    'var(--c1)', 'var(--c2)', 'var(--c3)', 'var(--c4)', 'var(--c5)',
    'var(--c6)', 'var(--c7)', 'var(--c8)', 'var(--c9)', 'var(--c10)'
  ];

  // Extract year keys dynamically (e.g., y2023, y2024, y2025)
  const yearKeys = data.length > 0 
    ? Object.keys(data[0]).filter(key => key.startsWith('y'))
    : [];
  
  const yearLabels = yearKeys.map(key => key.replace('y', ''));

  return (
    <div className="mb-card">
      <h2 className="mb-title">MONTHLY TOTAL INSECTS TRAPPED</h2>
      <div className="mb-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 8, right: 12, left: 12, bottom: 8 }}
            barCategoryGap="20%"
            barGap={2}
          >
            <CartesianGrid stroke="var(--grid-stroke)" strokeDasharray="3 3" />
            <XAxis dataKey="month" tickMargin={6} />
            <YAxis
              tickMargin={6}
              tickFormatter={(value) => value.toLocaleString('en-US')}
            />
            <Tooltip formatter={(value) => value.toLocaleString('en-US')} />
            <Legend
              verticalAlign="bottom"
              align="center"
              iconType="square"
              formatter={(v) => (
                <span style={{ marginLeft: 4, fontSize: 14 }}>{v.replace('y', '')}</span>
              )}
              payload={yearKeys.map((key, index) => ({
                id: key,
                value: yearLabels[index],
                type: 'square',
                color: colors[index % colors.length]
              }))}
            />
            {yearKeys.map((key, index) => (
              <Bar 
                key={key}
                dataKey={key} 
                name={yearLabels[index]} 
                fill={colors[index % colors.length]} 
                radius={[4, 4, 0, 0]} 
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
